export default __webpack_public_path__ + "static/media/widget_watchbox_vpmesc5_buy.046fdcf1.mp3";